import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { decisionAlertCommonPriceDrop, decisionMobileInternet } from './common-steps'
import { decisionMobileInternetReview, emailAddressReviewContest } from './decision-steps'

export const decisionScenarioA: Scenario = {
  id: 'decision-a',
  initialStep: Steps.DECISION_MOBILE_INTERNET,
  type: ScenarioType.DECISION,
  milestones: [decisionMobileInternet.id],
  version: '1',
  steps: [decisionMobileInternet],
}

export const decisionAlertScenarioA: Scenario = {
  id: 'decision-alert-a',
  initialStep: Steps.DECISION_ALERT_COMMON_PRICE_DROP,
  type: ScenarioType.DECISION_ALERT,
  milestones: [decisionAlertCommonPriceDrop.id],
  version: '1',
  steps: [decisionAlertCommonPriceDrop],
}

export const decisionReviewContestScenarioA: Scenario = {
  id: 'decision-review-contest-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.DECISION_REVIEW_CONTEST,
  milestones: [emailAddressReviewContest.id, decisionMobileInternetReview.id],
  version: '1',
  steps: [emailAddressReviewContest, decisionMobileInternetReview],
}
